import { render, staticRenderFns } from "./PageInsights.vue?vue&type=template&id=68ee9ca2&"
import script from "./PageInsights.vue?vue&type=script&lang=js&"
export * from "./PageInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js"
import QPage from 'quasar/src/components/page/QPage.js'
import QIcon from 'quasar/src/components/icon/QIcon.js'
import QSpace from 'quasar/src/components/space/QSpace.js'
import QBtn from 'quasar/src/components/btn/QBtn.js'
import QSelect from 'quasar/src/components/select/QSelect.js'
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js'
import QTabs from 'quasar/src/components/tabs/QTabs.js'
import QTab from 'quasar/src/components/tabs/QTab.js'
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js'
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js'
import QAvatar from 'quasar/src/components/avatar/QAvatar.js'
qInstall(component, 'components', {QPage,QIcon,QSpace,QBtn,QSelect,QLinearProgress,QTabs,QTab,QTabPanels,QTabPanel,QAvatar})
